import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Table, ITableProps } from './Table';

export type AnyType = string | number | boolean | Object;

export interface IKeyValueTableData {
  [key: string]: AnyType | AnyType[];
}

export interface IKeyValueTableProps extends Omit<ITableProps<IKeyValueTableData>, 'data'> {
  data: IKeyValueTableData;
}

// eslint-disable-next-line
const columns: any[] = [
  {
    Header: 'Key',
    accessor: 'key',
  },
  {
    Header: 'Value',
    accessor: 'value',
  },
];

export function KeyValueTable({ className, data, ...otherProps }: IKeyValueTableProps): React.ReactElement {
  const bem = bemBlock('table');

  const tableData = Object.keys(data).map(key => ({
    key,
    value: JSON.stringify(data[key]),
  }));

  return <Table className={bem(null, null, className)} data={tableData} columns={columns} {...otherProps} />;
}
